export const firstOf = (array) => (Array.isArray(array) ? array[0] : void 1);

// noinspection JSUnusedGlobalSymbols
export const secondOf = (array) => (Array.isArray(array) ? array[1] : void 1);

// noinspection JSUnusedGlobalSymbols
export const lastOf = (array) => {
  if (!Array.isArray(array)) return void 1;

  const length = array.length;

  return length ? array[length - 1] : void 1;
};
